module.exports = __webpack_public_path__ + "img/TopState2Y.46ee07cb.png";